// extracted by mini-css-extract-plugin
module.exports = {"quote-form":"QuoteForm_quote-form__Vrjv2"};